(function() {
    'use strict';

    angular
        .module('bhsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('param-tableau', {
            parent: 'entity',
            url: '/param-tableau?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'bhsApp.paramTableau.home.title'
            },
            views: {
                'content@bhs': {
                    templateUrl: 'app/entities/param-tableau/param-tableaus.html',
                    controller: 'ParamTableauController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('paramTableau');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('param-tableau-detail', {
            parent: 'entity',
            url: '/param-tableau/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'bhsApp.paramTableau.detail.title'
            },
            views: {
                'content@bhs': {
                    templateUrl: 'app/entities/param-tableau/param-tableau-detail.html',
                    controller: 'ParamTableauDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('paramTableau');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ParamTableau', function($stateParams, ParamTableau) {
                    return ParamTableau.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'param-tableau',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('param-tableau-detail.edit', {
            parent: 'param-tableau-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/param-tableau/param-tableau-dialog.html',
                    controller: 'ParamTableauDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ParamTableau', function(ParamTableau) {
                            return ParamTableau.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('param-tableau.new', {
            parent: 'param-tableau',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/param-tableau/param-tableau-dialog.html',
                    controller: 'ParamTableauDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                ordre: null,
                                titre: null,
                                descriptif: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('param-tableau', null, { reload: 'param-tableau' });
                }, function() {
                    $state.go('param-tableau');
                });
            }]
        })
        .state('param-tableau.edit', {
            parent: 'param-tableau',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/param-tableau/param-tableau-dialog.html',
                    controller: 'ParamTableauDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ParamTableau', function(ParamTableau) {
                            return ParamTableau.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('param-tableau', null, { reload: 'param-tableau' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('param-tableau.delete', {
            parent: 'param-tableau',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/param-tableau/param-tableau-delete-dialog.html',
                    controller: 'ParamTableauDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ParamTableau', function(ParamTableau) {
                            return ParamTableau.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('param-tableau', null, { reload: 'param-tableau' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
